import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  // reducers: {},
});

// export const { userLoggedIn, userLoggedOut } = userSlice.actions
export default accountsSlice.reducer;
